const t=t=>/^0[^.\s]+$/u.test(t);export{t as isZeroValueString};
